// extracted by mini-css-extract-plugin
export var content = "_4v-3";
export var list = "_4v-4";
export var settingsContent = "_4v-7";
export var settingsPanel = "_4v-8";
export var state = "_4v-6";
export var triggerBadge = "_4v-2";
export var triggerButton = "_4v-1";
export var triggerShell = "_4v-0";
export var unreadDot = "_4v-5";